<script setup>
import { RouterView, useRoute } from "vue-router";
import TempHeader from "@/components/dev/tempHeader.vue";
import Tabbar from "@/components/nav/tabbar/tabbar.vue";
import Preloader from "@/components/main/shared/preloader.vue";
import MainError from "@/components/main/error/mainError.vue";
import Toast from "@/components/main/toast/toast.vue";
import Notifications from "@/components/main/shared/notifications.vue";
import WA from "@/miniapp/tg";
import { baseAnalytics } from "@/utils/analytics/base";
import DownloadButton from "@/components/nav/downloadButton/downloadButton.vue";
import { MAIN_PAGES_OF_EACH_TAB } from "@/router";
import KYCEntryModal from "@/views/Profile/Base/KYCEntryModal.vue";
import Welcome from "@/views/Onboarding/Welcome.vue";
import { Index } from "@/captcha/captcha";
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from "vue";
import ConfirmationChallenge from "@/captcha/ui/ConfirmationChallenge.vue";

WA.expand();

import { useUiStore } from "@/stores/ui";
const uiStore = useUiStore();
uiStore.getLanguage();

baseAnalytics.initAnalyticsClient();

onBeforeMount(async () => {
  await Index.init();
});

onBeforeUnmount(() => {
  Index.destroy();
});

const route = useRoute();

// Модалки (<dialog> через showModal) лежат в top layer выше любого z-index: ошибки, тосты и
// нотификации тоже держим в top layer и переоткрываем на каждое новое, чтобы оказаться над модалкой.
const messagesRef = ref(null);
const messagesCount = computed(
  () => uiStore.errors.length + uiStore.toasts.length + uiStore.notifications.length,
);
const raiseMessages = () => {
  const el = messagesRef.value;
  if (!el?.showPopover) return;
  if (el.matches(":popover-open")) el.hidePopover();
  el.showPopover();
};
onMounted(raiseMessages);
watch(messagesCount, (count, prev) => {
  if (count > prev) raiseMessages();
});
</script>

<template>
  <Preloader v-if="uiStore.isPreloader" />
  <div
    ref="messagesRef"
    popover="manual"
    class="!fixed top-2 left-2 right-2 bottom-auto z-30 w-auto h-auto m-0 p-0 border-0 bg-transparent overflow-visible text-inherit"
    :class="{ 'top-[50px]': !WA.isApp }">
    <MainError />
    <Toast />
    <Notifications />
  </div>
  <div v-if="!WA.isApp" class="h-[50px]">
    <div
      class="fixed top-0 left-0 w-full z-10"
      :class="{ 'bg-back-1': !route.meta.transparentHeader }">
      <TempHeader />
    </div>
  </div>
  <div
    v-if="uiStore.isDataLoaded"
    class="scrollable flex flex-col overflow-y-auto overflow-x-hidden min-h-[calc(100vh-50px)] h-[calc(100vh-50px)]"
    :class="{ 'px-4': !route.meta.noPagePadding }">
    <RouterView />
    <div v-if="$route.meta.menu" class="pb-[90px]"></div>
  </div>
  <div
    v-if="$route.name !== 'Coinhold'"
    class="flex items-center justify-center w-full fixed bottom-[110px]">
    <DownloadButton v-if="MAIN_PAGES_OF_EACH_TAB.includes(route.path)" />
  </div>
  <div v-if="$route.meta.menu" class="h-[90px]">
    <div class="fixed left-0 bottom-0 w-full z-10">
      <Tabbar />
    </div>
  </div>
  <KYCEntryModal />
  <Welcome />
  <ConfirmationChallenge challenge="v3-hide" />
</template>

<style>
:deep(.intercom-container) {
  display: none;
}

:deep(.intercom-lightweight-app) {
  display: none;
}

:deep(.intercom-launcher) {
  display: none;
}

.intercom-launcher {
  display: none;
}

.intercom-lightweight-app {
  display: none;
}

#intercom-frame {
  display: none;
}
</style>
